// import { Application } from "@hotwired/stimulus"
// // <%- if bundler.importmap? %>
// // import consumer from "channels/consumer"
// // <%- else %>
// // import consumer from "../channels/consumer"
// // <%- end %>
// import consumer from "../channels/consumer"
// const application = Application.start()
// console.log('stimulus connected 2')
// console.log('is this working')
// // Configure Stimulus development experience
// application.debug = false
// application.consumer = consumer
// window.Stimulus = application


// export { application }


import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import consumer from "../channels/consumer"

const application = Application.start()
console.log('stimulus connected 2')
console.log('is this working')

// Autoload all *_controller.js files in this folder and subfolders
// const context = require.context(".", true, /_controller\.js$/)
// application.load(definitionsFromContext(context))

// Configure Stimulus development experience
application.debug = false
application.consumer = consumer
window.Stimulus = application

export { application }
